import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import Cookie from 'js-cookie';
import React, { useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { uploadImageUrl } from '@/services/oauthAdmin';
import { BYBIT_TOKEN_COOKIE_KEY } from '@/utils/constants';

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

const log = window.console;

const UploadImage: React.FC<any> = ({
  logoUrl,
  setLogoUrl,
  submitted = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>();
  const [$t] = useI18nContext();

  const beforeUpload = (file: RcFile) => {
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg';
    if (!isJpgOrPng) {
      message.error($t('oauthAdmin.uploadCondition'));
    }
    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      message.error($t('oauthAdmin.uploadCondition'));
    }
    return isJpgOrPng && isLt1M;
  };

  const handleChange: UploadProps['onChange'] = (
    info: UploadChangeParam<UploadFile>,
  ) => {
    log.log('info.xxx.status---', info.file);
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // handleUpload(info.file.originFileObj as RcFile);
      log.log('doneDee---------', info.file);
      setLogoUrl(info.file.response?.result?.logo_url);
      // Get this url from response in real world.
      getBase64(info.file.originFileObj as RcFile, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
    if (info.file.status === 'error') {
      message.error(info.file.error);
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>{$t('oauthAdmin.upload')}</div>
    </div>
  );

  return (
    <Upload
      name="file"
      listType="picture-card"
      action={uploadImageUrl}
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      withCredentials={true}
      headers={{
        usertoken: Cookie.get(BYBIT_TOKEN_COOKIE_KEY) || '',
      }}
      disabled={submitted}
    >
      {imageUrl || logoUrl ? (
        <img
          src={imageUrl || logoUrl}
          alt="auth_logo"
          style={{ width: '100%' }}
        />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

export default UploadImage;
